import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      width: '100%',
      position: 'relative',
      background: theme.palette.grey[200],
      '&::before': {
        content: "''",
        position: 'absolute',
        top: '-30px',
        left: 0,
        width: '100%',
        height: '50%',
        background: theme.palette.grey[300],
        transformOrigin: '0 50%',
        transform: 'skewY(-5deg)',

        [theme.breakpoints.down('sm')]: {
          display: 'none',
        },
      },

      [theme.breakpoints.down('sm')]: {
        justifyContent: 'flex-start',
        padding: 0,
      },
    },
    container: {
      display: 'flex',
      minHeight: '100vh',

      [theme.breakpoints.down('sm')]: {
        minHeight: 'auto',
        padding: theme.spacing(2, 2),
      },
    },
    contentContainer: {
      margin: '8px -8px -8px',

      [theme.breakpoints.down('sm')]: {
        margin: 0,
        flexDirection: 'row',
      },
    },
    logoContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      zIndex: 100,
      order: 2, // Desktop: appears on left (order doesn't matter in row layout)

      [theme.breakpoints.down('sm')]: {
        order: 1, // Mobile: appears first (top)
        padding: theme.spacing(3, 0, 2, 0),
      },
    },
    formContentContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      zIndex: 100,
      order: 2, // Desktop: appears on right

      [theme.breakpoints.down('sm')]: {
        order: 2, // Mobile: appears second (below logo)
        padding: 0,
      },
    },
    formContainer: {
      maxWidth: 500,
      width: '100%',
      padding: theme.spacing(4),

      [theme.breakpoints.down('sm')]: {
        padding: 0,
        maxWidth: '100%',
      },
    },
    footerContainer: {
      paddingTop: '20px',
      justifyContent: 'center',
      display: 'flex',
      flexWrap: 'wrap',

      [theme.breakpoints.down('sm')]: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2),
      },
    },
    footerLink: {
      fontSize: theme.typography.pxToRem(12),
      marginLeft: theme.typography.pxToRem(8),
      marginRight: theme.typography.pxToRem(8),
      lineHeight: theme.typography.pxToRem(20),
      color: theme.palette.grey[800],

      [theme.breakpoints.down('sm')]: {
        fontSize: theme.typography.pxToRem(11),
        marginLeft: theme.typography.pxToRem(4),
        marginRight: theme.typography.pxToRem(4),
      },
    },
  }),
);
